export const SET_ACTIVE_TAB = 'at/userManagement/common/SET_ACTIVE_TAB'
export const SET_USERS_WITHOUT_APPROVERS = 'at/userManagement/common/SET_USERS_WITHOUT_APPROVERS'
export const SET_LICENSE_COUNTERS = 'at/userManagement/common/SET_LICENSE_COUNTERS'
export const SET_VIEWER_SETTINGS = 'at/userManagement/common/SET_VIEWER_SETTINGS'
export const SET_NEW_USER_IDS = 'at/userManagement/common/SET_NEW_USER_IDS'
export const ADD_NEW_USER_IDS = 'at/userManagement/common/ADD_NEW_USER_IDS'
export const SET_VIEWER_MANAGEMENT_ASSIGNMENTS_COUNTERS = 'at/userManagement/common/SET_VIEWER_MANAGEMENT_ASSIGNMENTS_COUNTERS'
export const USERS_LIST_ADD = 'at/userManagement/common/USERS_LIST_ADD'
export const USERS_LIST_REMOVE = 'at/userManagement/common/USERS_LIST_REMOVE'
export const USERS_LIST_SET = 'at/userManagement/common/USERS_LIST_SET'
export const CLOSE_ALL_PANELS = 'at/userManagement/common/CLOSE_ALL_PANELS'
export const USER_MANAGEMENT_DATA_SET = 'at/userManagement/common/USER_MANAGEMENT_DATA_SET'

export const USERS_LIST_USER_GROUP_ID_UPDATE = 'at/userManagement/common/USERS_LIST_USER_GROUP_ID_UPDATE'



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/common/actionTypes.js